import { render, staticRenderFns } from "./DialogOneEnvelope.vue?vue&type=template&id=2f4b257e"
import script from "./DialogOneEnvelope.vue?vue&type=script&lang=js"
export * from "./DialogOneEnvelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports